/* eslint-disable max-len */
import { NextSeo } from 'next-seo'

import { HeadCanonicals } from 'src/components/_nextjs/HeadCanonicals'
import { config } from 'src/config'
import { getMetafield } from 'src/functions/util/getMetafield'

import type { Collection } from 'src/data/graphql-generated'
import type { ShopCanonicals } from 'src/types/Canonical'

interface CollectionSEOProps {
  collection: Collection
  handles: ShopCanonicals
}

export const CollectionSEO = ({ collection, handles }: CollectionSEOProps) => {
  const {
    metafields,
    title,
    description,
    seo: { title: seoTitle, description: seoDescription },
  } = collection

  const isNoIndex = getMetafield(metafields, 'seo', 'noindex') || false
  const pageType = getMetafield(metafields, 'layout', 'page_type')?.charAt(0) || 'c'

  return (
    <>
      <NextSeo
        title={seoTitle || title}
        titleTemplate={config.nextSeo.titleTemplate}
        description={(seoDescription || description || '').substring(0, 240)}
        noindex={isNoIndex}
        openGraph={{
          type: 'product.group',
          title: seoTitle || title,
          site_name: config.nextSeo.openGraph.site_name,
          description: seoDescription || description || '',
          images: config.nextSeo.openGraph.images,
        }}
      />

      <HeadCanonicals
        de={`/de/${pageType}/${handles.de}`}
        en={handles.en ? `/en/${pageType}/${handles.en}` : undefined}
      />
    </>
  )
}
